import { getKeyTitle, paddingZero } from "../js/tool";
import * as buddhism from "../buddha/buddhism";

// 编号方式
export const typeOptions = [
  { label: "规则区域", value: 1 },
  { label: "不规则区域", value: 2 },
];

// 编号方式
export const numberMethodOptions = [
  { label: "按照行与列生成编号", value: 1 },
  { label: "按照从上到下，从左到右顺序生成编号", value: 2 },
];

// 供奉方式
export const offeringMethodOptions = [
  { label: "选座供奉", value: 1 },
  { label: "按照顺序供奉", value: 2 },
];

// 供奉状态
export const worshipStatusOptions = [
  { label: "已供奉", value: 1 },
  { label: "未供奉", value: 2 },
];

export const orderStatusOptions = [
  { key: 0, title: "待支付" },
  { key: 1, title: "已支付" },
  { key: 2, title: "已超时" },
  { key: 3, title: "已取消" },
  { key: 4, title: "已退款" },
];

export const wishTypeList = [
  {
    value: 1,
    label: "祈福学业",
    children: [
      "定慧等持，学业进步。",
      "智慧无碍，学有所成。",
      "顺缘增上，融会贯通。",
      "增智开慧，妙笔生辉。",
      "勇猛精进，金榜题名。",
    ].map((item) => Object({ value: item, label: item })),
  },
  {
    value: 2,
    label: "祈福健康",
    children: [
      "身体健康，平安喜乐。",
      "拨除重病，安住清净。",
      "消除业障，如意安康。",
      "身心安泰，清净无染。",
      "消灾免难，益寿延年。",
    ].map((item) => Object({ value: item, label: item })),
  },
  {
    value: 3,
    label: "祈福财富",
    children: [
      "众善奉行，财运亨通。",
      "慈悲利他，财源广进。",
      "广行六度，安乐富足。",
      "广结善缘，生意兴隆。",
      "法喜充满，富贵吉祥。",
    ].map((item) => Object({ value: item, label: item })),
  },
  {
    value: 4,
    label: "祈福事业",
    children: [
      "心想事成，妙境随心。",
      "一帆风顺，前程似锦。",
      "步步高升，蒸蒸日上。",
      "梦想成真，安居乐业。",
      "与人为善，兴旺发达。",
    ].map((item) => Object({ value: item, label: item })),
  },
  {
    value: 5,
    label: "祈福姻缘",
    children: [
      "花好圆月，佳偶天成。",
      "永结同心，幸福美满。",
      "天缘巧合，美满良缘。",
      "花开并蒂，琴瑟和鸣。",
      "相亲相爱，郎才女貌。",
    ].map((item) => Object({ value: item, label: item })),
  },
];

export const nameTypeList = [
  { key: 1, title: "个人" },
  { key: 2, title: "阖家" },
  { key: 3, title: "公司" },
];

// 订单来源
export const catOptions = [
  { key: 1, title: "h5" },
  { key: 2, title: "管理后台" },
];

export const expireOptions = [
  { key: 1, title: "1天" },
  { key: 2, title: "2天" },
  { key: 3, title: "3天" },
  { key: 7, title: "7天" },
  { key: 15, title: "15天" },
  { key: 30, title: "30天" },
];

export const getExpireText = function (expire) {
  return getKeyTitle(expireOptions, expire);
};

export const getCatText = function (cat) {
  return getKeyTitle(catOptions, cat);
};

export const getWorshipStatusText = function (status) {
  return getKeyTitle(worshipStatusOptions, status, "value", "label");
};

export const getOrderStatusText = function (status) {
  return getKeyTitle(orderStatusOptions, status);
};

export const getWishTypeText = function (type) {
  return getKeyTitle(wishTypeList, type, "value", "label");
};

export const getShowPrice = function (price) {
  price = price || 0;
  return `¥ ${(price / 100).toFixed(2)}`;
};

export const getIntegerAndDecimal = function (price) {
  return {
    integer: Math.floor(price / 100), // 价格整数位
    decimal: paddingZero(price % 100, 2), // 价格小数位
  };
};

export const dealNicheOrder = function (item) {
  item.location = `${item.province}-${item.city}-${item.district}`;
  item.statusText = getOrderStatusText(item.status);
  item.numText = `${item.tabletBlockItem.tabletBlock.tabletRegion.name}-${item.tabletBlockItem.tabletBlock.name}-${item.tabletBlockItem.num}`;
  const start = new Date(item.start_time * 1000);
  const end = new Date(item.end_time * 1000);
  // item.canRenewal = end.getTime() - Date.now() >= -3 * 24 * 60 * 60 * 1000; // 未到期及到期后三天内可续供
  item.provideTime = `${start.pattern("yyyy年M月d日")}-${end.pattern(
    "yyyy年M月d日"
  )}`;
  item.orderPrice = getShowPrice(item.price);
  let nichePrice = item.price;
  if (item.order_info) {
    try {
      const detail = JSON.parse(item.order_info);
      item.showArea = detail.showArea;
      if (detail.nichePrice) {
        nichePrice = detail.nichePrice;
      }
      if (item.cat == 2) {
        item.bill = detail.bill;
        item.processor = detail.processor;
      }
    } catch (e) {
      console.error(e);
    }
  }
  item.lightPrice = getShowPrice(nichePrice);

  if (item.tablet_info) {
    try {
      const tablet_info = JSON.parse(item.tablet_info); // 牌位信息
      const relationList = buddhism.getBuddhismTypeOptions(
        buddhism.buddhismRelationList
      );
      const relationTarget = relationList.find(
        (item) => item.key === tablet_info?.relation
      );
      const personList = tablet_info?.personList; // 牌位
      const posterityList = tablet_info?.posterityList; // 阳上
      item.relationText = relationTarget?.title;
      item.personText = personList.map((item) => item.name).join(",");
      item.posterityText = posterityList.map((item) => item.name).join(",");
      // item.tablet_info = tablet_info;
    } catch (e) {
      console.error(e);
    }
  }
};

export const dealNiche = function (item) {
  item.disabled = item.is_open == 2; // 禁用
  return item;
};
